export default __webpack_public_path__ + "static/media/chevron-up.817b55d4.svg";